export const config = {
  API_URL: 'https://backend.surveydemolink.in/api/',
};